import apolloClient from "../apollo";
import requestTrial, { readRequestTrialResult } from "../graphql/mutations/requestTrial";
import startTrial, { readStartTrialResult } from "../graphql/mutations/startTrial";
import trialExchange, { readTrialExchangeResult } from "../graphql/mutations/trialExchange";
import getTrialQuery, { readTrial } from "../graphql/queries/getTrial";

export const requestFreeTrial = ({ email }, turingToken) =>
	apolloClient()
		.mutate({
			mutation: requestTrial,
			variables: { email },
			context: {
				headers: { "x-turing-token": turingToken },
			},
		})
		.then(readRequestTrialResult);

export const startFreeTrial = ({ trialId, usageSelect, roleSelect, labName }) =>
	apolloClient()
		.mutate({
			mutation: startTrial,
			variables: {
				trialId,
				extension: { groupName: labName, usageSelect, roleSelect },
			},
		})
		.then(readStartTrialResult);

export const exchangeTrial = (requestAccessToken, req, res) =>
	apolloClient({ req, res })
		.mutate({ mutation: trialExchange, variables: { requestAccessToken } })
		.then(readTrialExchangeResult);

export const getTrialById = context =>
	apolloClient(context)
		.query({
			query: getTrialQuery,
			variables: { trialId: context.query.trialId },
		})
		.then(readTrial);
